export default function buildPatchListingTagData({
    apiEndpoint,
    apiTools
}) {
    return async function patchListingTagData(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }` 
        })
       
        const res = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}